import { render, staticRenderFns } from "./teacherCardList.vue?vue&type=template&id=cffb1c32&scoped=true&"
import script from "./teacherCardList.vue?vue&type=script&lang=js&"
export * from "./teacherCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffb1c32",
  null
  
)

export default component.exports